import { MMP } from "./MMP";
import { Milestone } from "./Milestone";
export class TCProject {
    
    ProjectMMP :MMP[] ;
    ProjectMilestones:Milestone[];
    ProjectId: number;
    ProjectTitle: string;
    SubmitterId:string;
    Submitter: string;
    SubmitterOrgCode: string;
    FinancialControllerIDs :string;
    FinancialController: string;
    FinancialControllerOrgCode: string;
    IsFCApproved:boolean;
    FinancialControllerProxyIDs:string;
    FinancialControllerProxy:string;
    ProductManagerIDs :string;
    ProductManager: string;
    ProductManagerOrgCode: string;
    IsPDMApproved:boolean;
    ProductManagerProxyIDs:string
    ProductManagerProxy:string
    ServiceManagerIDs :string;
    ServiceManager: string;
    ServiceManagerOrgCode: string;
    IsSMApproved:boolean;
    ServiceManagerProxyIDs: string;
    ServiceManagerProxy: string;
    ProjectManagerIDs :string;
    ProjectManager: string;
    ProjectManagerOrgCode: string;
    IsPMApproved:boolean;
    ProjectManagerProxyIDs: string;
    ProjectManagerProxy: string;
    ProcurementEngineerIDs :string;
    ProcurementEngineer: string;
    ProcurementEngineerOrgCode: string;
    IsPEApproved:boolean;
    ProcurementEngineerProxyIDs: string;
    ProcurementEngineerProxy: string;
    SystemArchitectIDs:string;
    SystemArchitect:string;
    IsSAApproved:string;
    SystemArchitectProxyIDs:string;
    SystemArchitectProxy:string;
    WatchListIDs:string;
    WatchList:string;
    IsWLApproved:boolean;
   // MeasureStatusId: number;:WatchListIDs
    ProjectStatusId: number;
    DNA: string;
    TargetSol: string;
    OptionA: string;
    OptionB: string;
    OptionC: string;
    IsActive: boolean;
    CreatedBy: number;
    CreatedOn: Date;
    ModifiedBy: number;
    ModifiedOn: Date;
    MilestoneID:number;
    MilestoneName:string;
    BusinessAreaId: number;
    BusinessLineId: number;
    
}
  
    